import { Tooltip, Typography } from '@mui/material';

function CommentSection(props) {
  return (
    <Typography
      key={props.index}
      width={300}
      sx={{
        cursor: 'default',
        margin: 'auto',
        fontSize: '14px',
        maxHeight: '100px',
        overflow: 'auto',
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-track': {
          backgroundColor: '#f1f1f1',
          borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb': {
          backgroundColor: '#c1c1c1',
          borderRadius: '10px',
        },
        '&::-webkit-scrollbar-thumb:hover': {
          backgroundColor: '#a8a8a8',
        },
      }}
    >
      {props.comments}
    </Typography>
  );
}
function TableComments(props) {
  if (props.phase && props.phase === 'Coordinator Review') {
    const comments = (
      <>
        Comments: {props.comments} <br />
        <br />
        Excess and Obsolete:{' '}
        {props.eoComments.trim() !== ''
          ? props.eoComments
          : 'No Excess and Obsolete comments'}
      </>
    );
    return (
      <Tooltip
        key={props.index}
        title={comments}
        componentsProps={{
          tooltip: {
            sx: {
              fontSize: '12px',
            },
          },
        }}
      >
        <CommentSection key={props.index} comments={comments} />
      </Tooltip>
    );
  }
  return (
    <Tooltip
      key={props.index}
      title={props.comments}
      componentsProps={{
        tooltip: {
          sx: {
            fontSize: '12px',
          },
        },
      }}
    >
      <CommentSection key={props.index} comments={props.comments} />
    </Tooltip>
  );
}

export default TableComments;
